<template>
  <div v-if="plan" class="account-cards__item">
    <div class="account__heading">
      {{ $t('account.subscription.title') }}
    </div>
    <div class="account-block">
      <span class="account__subtitle">
        {{ $t('subscription.plans.planType') }}
      </span>
      <span v-if="!plan.editorAccess" class="account__text">{{
        $t('subscription.plans.noPlan')
      }}</span>
      <span v-else-if="plan.editorAccess" class="account__text">{{
        $t(`subscription.plans.${plan.type}`)
      }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CardPlans',
  computed: {
    ...mapState({
      account: (state) => state.distributors.distributorData,
      plan: (state) => state.subscriptions.planData
    })
  },

  methods: {}
};
</script>
